/* eslint-disable no-use-before-define */
import React from 'react'
import { getId, } from '../../twd'

export const Action = ({action, setAction}) => {
    const id = getId()

    return <React.Fragment>
        <div className="form-group"
            style={{paddingLeft:'0px', paddingRight:'0px'}}
        >
            <label
                className='label'
                htmlFor={id}
                style={{ lineHeight:'20px', display:'inline', textAlign:'left', marginBottom:0 }}
            >Action</label>

            <div className="select-wrapper">
            <select
                id={id}
                data-name="calculator-enter-input-action"
                defaultValue={action}
                onChange={(e) => setAction(e.target.value)}
                className="form-control"
            >
                <option value="B" selected={action==='B'}>Buy</option>
                <option value="S" selected={action==='S'}>Sell</option>
            </select>
            </div>
        </div>
    </React.Fragment>
}
